var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
// @ts-check
import { Link } from '@bottlebooks/gatsby-design-system';
/**
 *
 * @param {object} props
 * @param {(any) => void} [props.onClick] The click handler.
 * @param {string | import('history').Location} [props.to] The internal link target to go to.
 * @param {boolean} [props.replace] Replace the state.
 * @param {string} [props.href] An external link to go to.
 * @param {keyof typeof import('./buttonVariants').default} [props.variant] The button's variant.
 * @param {boolean} [props.disabled] Disables the button.
 * @param {React.ReactNode} props.children
 * @param {string} [props.title]
 * @param {string} [props.className]
 * @param {string | React.ElementType} [props.as]
 * @param {React.ElementType} [props.fallback] An optional fallback element if no link or onClick handler is given
 * @param {'button' | 'submit'} [props.type] The button type for forms.
 * @returns {React.ReactElement}
 */
export default function Button(_a) {
    var { onClick, to, replace, href, children, variant = 'default', disabled, fallback = 'button', type = 'button' } = _a, rest = __rest(_a, ["onClick", "to", "replace", "href", "children", "variant", "disabled", "fallback", "type"]);
    return (_jsx(Link, Object.assign({ onClick: onClick, to: to, replace: replace, href: href, variant: "button" // `link.button` sets the general button styles.
        , sx: Object.assign(Object.assign({ display: 'inline-block', variant: `button.${variant}` }, (disabled && { opacity: 0.5 })), { ':hover, :focus': {
                textDecoration: 'none',
            } }), fallback: fallback, 
        // @ts-ignore
        type: type, disabled: disabled }, rest, { children: children })));
}
//# sourceMappingURL=Button.js.map